<script>
import { mapGetters } from 'vuex'
export default
{
    name: 'mv-wishlist-category-form',

    computed:
    {
        ...mapGetters({
            artists: 'artistList',
        }),

    },

    methods:
    {
        save()
        {
            this.$emit('save')
        },

        submit()
        {
            this.$refs.form.submit()
        },

        addFile(file)
        {
            this.model.attachments.push(file)
        },

        removeFile(file)
        {
            for (let i = 0; i < this.model.attachments.length; ++i)
            {
                const item = this.model.attachments[i]
                if (file.id == item.id)
                {
                    this.model.attachments.splice(i, 1)
                }
            }

        },

    },

    props:
    {
        model: Object,
        edit: Boolean,
    }

}
</script>

<template>
<div class="container">
    <form @submit.prevent.stop="save" ref="form">
        <div class="form-group row">
            <label for="name" class="col-md-4 control-label">
                {{ $t('WISHLIST.NAME') }}
            </label>
            <div class="col-md-6">
                <input type="text" class="form-control" v-model="model.name" required>
            </div>
        </div>

        <div class="form-group row">
            <label for="name" class="col-md-4 control-label">
                {{ $t('ARTIST.ARTISTS') }}
            </label>
            <div class="col-md-6">
                <v-select :options="artists" v-model="model.artists" label="name" multiple>
                    <template slot="option" slot-scope="option">
                        <div class="row option-row">
                            <div class="col-sm-2 hidden-sm hidden-xs">
                                <div v-if="option.attachments && option.attachments.length">
                                    <img :src="option.attachments[0].thumbnail_url">
                                </div>
                            </div>
                            <div class="col-sm-10">
                                <div class="text">
                                    {{ option.name }} 
                                </div>
                            </div>
                        </div>
                    </template>
                </v-select>
            </div>
        </div>

        <div class="form-group row">
            <label class="col-md-4 control-label">
                {{ $t('GENERAL.IMAGES') }}
            </label>
            <div class="col-md-6">
                <mv-image-uploader ref="uploader" multiple @upload-done="addFile($event)" accept="image/*" :width="512" :height="512"></mv-image-uploader>
            </div>
        </div>

        <div class="form-group row">
            <div class="col-md-4">

            </div>
            <div class="col-md-6">
                <mv-attachment v-for="img in model.attachments" :key="img.id" :attachment="img" can-remove @remove="removeFile">
                </mv-attachment>
            </div>
        </div>
    </form>
</div>
</template>


// WEBPACK FOOTER //
// src/components/forms/WishlistCategoryForm.vue